import { css } from 'styled-components';

const media = {
  tablet: 'min-width: 768px',
};

export default (breakpoint, styles) => css`
  @media (${media[breakpoint]}) {
    ${styles};
  }
`;



// WEBPACK FOOTER //
// ../pos-master/packages/pos-helper/src/media.js